import { FC, ReactElement, useState } from "react"
import {
  CreateChallengeRedeemCodeRequestSchema,
  ChallengesService,
  Challenge
} from "../sdk"
import { Controller, useForm } from "react-hook-form"
import useError from "../hooks/useError"
import classNames from "classnames"
import Input from "../components/Input"
import Button from "../components/Button"
import Checkbox from "../components/Checkbox"

type Props = {
  onSuccess?(): void
  challenge?: Challenge
}

const AddRedeemCodeForm: FC<Props> = ({ onSuccess, challenge }) => {
  const [loading, setLoading] = useState<boolean>(false)

  const [autoGenerateCode, setAutoGenerateCode] = useState<boolean>(true)

  const { control, formState, handleSubmit } = useForm<CreateChallengeRedeemCodeRequestSchema>()
  const { handleError } = useError()

  const onSubmit = async({
    autogeneratedRedeemCodeLength,
    redeemCode,
    challengeId,
    enabled,
    maximumUses
  }: CreateChallengeRedeemCodeRequestSchema): Promise<void> => {
    setLoading(true)
    try {
      await ChallengesService.createChallengeRedeemCode({
        autogeneratedRedeemCodeLength: Number(autogeneratedRedeemCodeLength),
        redeemCode,
        challengeId: Number(challengeId),
        enabled,
        maximumUses: Number(maximumUses)
      })
      if (onSuccess) {
        onSuccess()
      }
    } catch (err) {
      handleError(err)
    }
    setLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classNames(loading && "opacity-50 pointer-events-none")}>
      <Checkbox
        checked={autoGenerateCode}
        onChange={(): void => setAutoGenerateCode(!autoGenerateCode)}
        id="autoGenerate"
        label="Genera codice random"
        containerClassName="w-56 @apply flex items-center justify-between"
        className="ml-4"
      />

      <Controller
        name="autogeneratedRedeemCodeLength"
        control={control}
        defaultValue={5}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input
              onChange={onChange}
              value={value}
              disabled={!autoGenerateCode}
              error={formState.errors.autogeneratedRedeemCodeLength?.message}
              label="Lunghezza codice autogenerato"
              className="my-3"
            />
          )
        }}
      />

      <Controller
        name="redeemCode"
        control={control}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input
              onChange={onChange}
              value={value}
              disabled={autoGenerateCode}
              error={formState.errors.redeemCode?.message}
              label="Redeem Code"
              className="my-3"
            />
          )
        }}
      />

      <Controller
        name="challengeId"
        control={control}
        rules={{ required: "Campo Obbligatorio" }}
        defaultValue={challenge?.id}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input
              onChange={onChange}
              value={value}
              error={formState.errors.challengeId?.message}
              label="Challenge ID"
              className="my-3"
              // disabled={challenge !== null}
            />
          )
        }}
      />

      <Controller
        name="maximumUses"
        control={control}
        rules={{ required: "Campo Obbligatorio" }}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Input
              onChange={onChange}
              value={value}
              error={formState.errors.maximumUses?.message}
              label="Numero massimo di utilizzi"
              className="my-3"
            />
          )
        }}
      />

      <Controller
        name="enabled"
        control={control}
        defaultValue={true}
        render={({ field: { onChange, value } }): ReactElement => {
          return (
            <Checkbox
              checked={value}
              label="Abilitato"
              className="ml-4"
              containerClassName="w-56 my-3"
              onChange={onChange}
            />
          )
        }}
      />

      <Button
        type="submit"
        className="w-full"
      >
        Aggiungi Codice
      </Button>
    </form>
  )
}

export default AddRedeemCodeForm